module.exports = __webpack_public_path__ + "static/img/bgAboutSr.91f32ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bgAboutSr.jpg
// module id = VDTU
// module chunks = 13